/**
 * SummaryMetricsBar - 6 metric cards in a row
 */

import React from 'react';
import {
  Wallet,
  TrendingUp,
  CreditCard,
  Landmark,
  ArrowLeftRight,
  AlertTriangle,
} from 'lucide-react';
import type { SummaryMetricsBarProps } from '../../../../types/lending-report.types';
import { formatINR } from '../../../../types/lending-report.types';

const MetricCard: React.FC<{
  icon: React.ReactNode;
  label: string;
  value: string;
  iconBg: string;
}> = ({ icon, label, value, iconBg }) => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '12px',
    borderRadius: '12px',
    backgroundColor: '#ffffff',
    border: '1px solid #e5e7eb',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    minWidth: 0,
  }}>
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '32px',
      height: '32px',
      borderRadius: '8px',
      backgroundColor: iconBg,
      marginBottom: '8px',
    }}>
      {icon}
    </div>
    <span style={{ fontSize: '11px', color: '#6b7280', textAlign: 'center', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{label}</span>
    <span style={{ fontSize: '14px', fontWeight: 700, color: '#111827', marginTop: '2px' }}>{value}</span>
  </div>
);

export const SummaryMetricsBar: React.FC<SummaryMetricsBarProps> = ({ report }) => {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '12px' }}>
      <MetricCard
        icon={<Wallet style={{ width: 16, height: 16, color: '#16a34a' }} />}
        label="Net Monthly Income"
        value={formatINR(report.netMonthlyIncome)}
        iconBg="#f0fdf4"
      />
      <MetricCard
        icon={<TrendingUp style={{ width: 16, height: 16, color: '#2563eb' }} />}
        label="FOIR"
        value={`${report.foir.toFixed(1)}%`}
        iconBg="#eff6ff"
      />
      <MetricCard
        icon={<CreditCard style={{ width: 16, height: 16, color: '#9333ea' }} />}
        label="Active EMIs"
        value={String(report.activeEMIs)}
        iconBg="#faf5ff"
      />
      <MetricCard
        icon={<Landmark style={{ width: 16, height: 16, color: '#4f46e5' }} />}
        label="Avg Closing Balance"
        value={formatINR(report.avgClosingBalance)}
        iconBg="#eef2ff"
      />
      <MetricCard
        icon={<ArrowLeftRight style={{ width: 16, height: 16, color: '#0d9488' }} />}
        label="Inflow/Outflow"
        value={`${report.inflowOutflowRatio.toFixed(2)}x`}
        iconBg="#f0fdfa"
      />
      <MetricCard
        icon={<AlertTriangle style={{ width: 16, height: 16, color: '#dc2626' }} />}
        label="Bounce Events"
        value={String(report.bounceEvents)}
        iconBg="#fef2f2"
      />
    </div>
  );
};
